export enum AccordionVariations {
  withTabs = 'accordionWithTabs',
  withWhatsApp = 'accordionWithWhatsApp',
}
